export default __webpack_public_path__ + "static/media/TB 93_Benh vien DKKV Cau Ngang_Nha xe.dff66089.pdf";